import React from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses } from '@mui/material';

const CustomTooltip = styled(({ className, maxWidth, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }}/>
))(({ theme, maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#4C5B62',
    color: '#ffffff',
    maxWidth: maxWidth || '339px',
    fontSize: '14px',
    borderRadius: '6px',
    lineHeight: '20px',
    padding: '16px 20px 20px 20px',
    fontWeight: 400,
    fontFamily: 'Source Sans Pro',
    alignSelf: 'stretch',
    fontStyle: 'normal',
    letterSpacing: '0px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#4C5B62',
    '&:before': {
      backgroundColor: '#4C5B62',
      border: 'none',
    }   
  },
}));

export default CustomTooltip;
